import { supabase } from "~/integrations/supabase/client";

export const fetchProfilesUtil = async (
  userIds: string[]
): Promise<Record<string, any>> => {
  if (userIds.length === 0) {
    return {};
  }

  try {
    const { data: profilesData, error: profilesError } = await supabase
      .from("profiles")
      .select("id, name, lastname, email, role")
      .in("id", userIds);

    if (profilesError) throw profilesError;

    const profileMap: Record<string, any> = {};
    if (profilesData) {
      profilesData.forEach((profile) => {
        profileMap[profile.id] = profile;
      });
    }
    return profileMap;
  } catch (error) {
    console.error("Error fetching profiles:", error);
    return {};
  }
};
